








































import {Component, Vue} from "vue-property-decorator"
import {vxm} from "@/store"
import Gravatar from "@/components/Gravatar.vue"

@Component({components: {Gravatar}})
export default class AdminUserList extends Vue {

  get users() {
    return vxm.user.users
  }

  async mounted() {
    await vxm.user.fetchUsers(true)
  }

}
